export var VERSION = '1.12.0';
//# sourceMappingURL=version.js.map